// extracted by mini-css-extract-plugin
export var aiStarIcon = "_td-2";
export var container = "_td-4";
export var dismissButton = "_td-3";
export var hasPaddingBottom = "_td-6";
export var last = "_td-e";
export var scrollbarThumb = "_td-c";
export var scrollbarTrack = "_td-b";
export var selected = "_td-9";
export var spin = "_td-1";
export var spinning = "_td-0";
export var suggestionItem = "_td-d";
export var suggestionsPanel = "_td-5";
export var tonePill = "_td-8";
export var tonesContainer = "_td-7";
export var unselected = "_td-a";